import FormConstants from '../constants/FormConstants';

const LOCAL_BASE_URL = 'http://localhost:4500/api/v1';
const LOCAL_BASE_HOST = 'localhost:4500';
const LOCAL_PORTAL_URL = 'http://localhost:4500';

const getRuntimeLocationConfig = () => {
  if (typeof window === 'undefined') {
    return {
      baseUrl: LOCAL_BASE_URL,
      baseHost: LOCAL_BASE_HOST,
      portalUrl: LOCAL_PORTAL_URL
    };
  }

  const {hostname, host, origin} = window.location;
  const isLocalHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0';

  if (isLocalHost) {
    return {
      baseUrl: LOCAL_BASE_URL,
      baseHost: LOCAL_BASE_HOST,
      portalUrl: LOCAL_PORTAL_URL
    };
  }

  return {
    baseUrl: `${origin}/api/v1`,
    baseHost: host,
    portalUrl: origin
  };
};

const baseEnvironment = {
  base: true,
  reqTimeout: 90000,
  apiEndPoints: {
    auth: {
      base: '/auth',
      login: '/login',
      signUp: '/sign-up',
      verifyUser: '/verify-user',
      createPassword: '/create-password',
      forgetPassword: '/forgot-password',
      resetPassword: '/reset-password',
      azureLogin: '/azure/login',
      LDAPLogin: '/ldap/login',
      OAuthLogin: '/oauth/login',
      OAuthLogout: '/oauth/logout',
      OAuthCallback: '/oauth/callback',
      smartConfiguration: '/.well-known/smart-configuration',
      epicLogin: '/epic/login',
      feedback: '/feedback',
      easyEmail: '/easyEmail',
      versioninfo: '/version',
      envConfig: '/environment-variables',
      generateOtp: '/generate-otp',
      verifyOtp: '/verify-otp',
      athenaLogin: '/athena/login',
      adfsLogin: '/saml/adfs/login',
      adfsCallBack: '/saml/callback',
      adfsLogout: '/saml/logout'
    }
  },
  muiLicenseKey:
    '8ddb316518c835be0db96875b79063d3Tz0xMjEwMjIsRT0xNzkzMjMxOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
  defaultRowsLimit: 25,
  rowsPerPageOptions: [25, 50, 100],
  defaultvitalLimit: 40,
  rowsvitalPerPageOptions: [10, 20, 30, 40],
  encryptDataKey: '542EFDA4963DEF54BAC6519E6287C'
};

type Environment = {
  [key: string]: any;
  encryptDataKey?: string | any;
  API_URL: string;
  dev: boolean;
  production: boolean;
  baseUrl: string;
  baseHost: string;
  portalUrl: string;  
  encryptLocalStorage: boolean;
  encryptLocalStorageKey: string;
  encryptURLKey: string;
  loginType: string;
  InActivityTimeOutInMins: any;
  InActivityPromptBeforeIdleInMins: any;
};

export const environment: Environment = {
  ...baseEnvironment,
  ...getRuntimeLocationConfig(),
  API_URL: '/locEnvUrl',
  dev: true,
  production: false,
  encryptLocalStorage: true,
  encryptLocalStorageKey: 'f74808fb03f94ef8f64350a37918c1b0518c',
  encryptURLKey: 'VAeKOUOjb5iSyuZq1q6NFikq08kkLvrN',
  loginType: FormConstants.LOGIN_TYPE.ALL, 
  InActivityTimeOutInMins: 10,
  InActivityPromptBeforeIdleInMins: 1
};
